import React, { Component } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const CustomSvgIcon = withStyles({
  root: { width: "inherit", height: "inherit" }
})(SvgIcon);

class MaunentCrownLogoIcon extends Component {
  static propTypes = {
    style: PropTypes.object
  };

  static defaultProps = {
    style: null
  };

  render() {
    const { style } = this.props;

    return (
      <CustomSvgIcon style={style} viewBox="-1 -1 426 246">
        <path d="M392 32L369.373 9.37258C378.525 0.220648 392.288 -2.51714 404.246 2.43586C416.203 7.38885 424 19.0572 424 32H392ZM212 32L189.373 9.37258C201.869 -3.1242 222.131 -3.1242 234.627 9.37258L212 32ZM122 122L144.627 144.627L122 167.255L99.3726 144.627L122 122ZM32 32H0C0 19.0572 7.79654 7.38885 19.7541 2.43586C31.7117 -2.51714 45.4755 0.220648 54.6274 9.37258L32 32ZM360 244V32H424V244H360ZM414.627 54.6274L324.627 144.627L279.373 99.3726L369.373 9.37258L414.627 54.6274ZM279.373 144.627L189.373 54.6274L234.627 9.37258L324.627 99.3726L279.373 144.627ZM234.627 54.6274L144.627 144.627L99.3726 99.3726L189.373 9.37258L234.627 54.6274ZM99.3726 144.627L9.37259 54.6274L54.6274 9.37258L144.627 99.3726L99.3726 144.627ZM64 32V244H0V32H64ZM324.627 99.3726L414.627 189.373L369.373 234.627L279.373 144.627L324.627 99.3726ZM324.627 144.627L243.127 226.127L197.873 180.873L279.373 99.3726L324.627 144.627Z" />
      </CustomSvgIcon>
    );
  }
}

export default MaunentCrownLogoIcon;
